import React, { useContext, useEffect, useRef, useState } from "react";
import { GetPagePermission } from "../../components/UserPagePermission";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import userPermissionContext from '../../../context/userPermissionContext';
import { KTSVG } from '../../../_metronic/helpers';
import BackendTable from 'react-backend-table';

function BuWiseMotorCycle() {
    const { jwt, businessUnit } = useContext(userPermissionContext);
    const hasPermission = GetPagePermission('/report-buWiseMotorCycle');
    const backendTableRef = useRef(null);
    const [reload, setReload] = useState(false);
    const [formData, setFormData] = useState({
        vehicleStatus: "Active",
    });

    const columns = [
        {
            title: 'SL',
            field: 'serial',
            sortable: false,
            searchable: false,
            thStyle: { textAlign: 'center' },
            tdStyle: { textAlign: 'center' },
        },
        {
            title: 'Project Name',
            field: 'projectName',
            sortable: true,
            searchable: true,
        },
        {
            title: 'Sub Project',
            field: 'subProjectName',
            sortable: true,
            searchable: true,
        },
        {
            title: 'In House Vehicle',
            field: 'inHouseVehicle',
            sortable: true,
            searchable: false,
            thStyle: { textAlign: 'right' },
            tdStyle: { textAlign: 'right' },
        },
        {
            title: 'Third Party Vehicle',
            field: 'thirdPartyVehicle',
            sortable: true,
            searchable: false,
            thStyle: { textAlign: 'right' },
            tdStyle: { textAlign: 'right' },
        },
        {
            title: 'Total Vehicle Qty',
            field: 'totalVehicleQty',
            sortable: true,
            searchable: false,
            thStyle: { textAlign: 'right' },
            tdStyle: { textAlign: 'right' },
        },
    ];

    const options = {
        url: process.env.REACT_APP_API_URL + 'projectWiseMotorCycleReport?currentProject=' + businessUnit.idProjects,
        authorization: 'Bearer ' + jwt.token,
        perPage: [12, 24, 50, 'All'],
        orderBy: 'totalVehicleQty',
        orderType: 'desc',
        columnSearch: true,
        extraData: formData,
    };

    useEffect(() => {
        backendTableRef.current?.reload();
    }, [businessUnit, reload]);

    const vehicleStatus = [
        { label: 'All', value: '' },
        { label: 'Active', value: 'Active' },
        { label: 'Inactive', value: 'Inactive' }
    ]

    const handleInputOnChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setReload(!reload);
    }

    return (
        <>
            {hasPermission === 1 &&
                <div className="card card-custom">
                    <div className="card-header d-flex flex-direction-row justify-content-between">
                        <div className='card-title w-50'>
                            <span>
                                <KTSVG
                                    path='/media/svg/icons/Text/Bullet-list.svg'
                                    className='svg-icon-1 svg-icon-primary'
                                />
                            </span>
                            <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                                Bu Wise Motor Cycle Number
                            </span>
                        </div>
                        <div className='w-50 d-flex justify-content-end align-items-center'>
                            <label htmlFor="vehicleStatus" className="col-form-label mx-2">Vehicle Status: </label>
                            <div className="">
                                <select className="form-select form-select-sm" id="vehicleStatus" name="vehicleStatus" value={formData.vehicleStatus} onChange={handleInputOnChange} >
                                    {vehicleStatus.map(function (item, id) {
                                        return <option key={id} value={item.value}>{item.label}</option>
                                    })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="ml-12">
                        <div className="" style={{ overflowX: "hidden" }}>
                            <BackendTable ref={backendTableRef} columns={columns} options={options} />
                        </div>
                    </div>
                </div>
            }
            {hasPermission === 0 &&
                <div className="card card-custom" style={{ padding: "15px" }}>
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40}
                            ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            }
        </>
    );
}

export default BuWiseMotorCycle;
